<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <fragment v-if="form">
      <EndorsementForm
        :form="form"
        @submit="checkSubmit"
        name-button="SOLICITAR"
        @cancel="previousPage"
        is-request-endorsement
        is-create
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPage"
      title="SOLICITAÇÃO DE ENDOSSO CRIADA"
      text="Nova solicitação de endosso foi criada com sucesso."
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
    <ModalConfirmReproveEndoserment
      @close="closeModalReprove"
      v-model="modalCancelReprove"
      title="CANCELAMENTO DE ENDOSSO"
      text="Você tem certeza de que deseja solicitar o cancelamento deste endosso. O cancelamento pode afetar a regra de cobertura prevista na apólice atual."
      has-cancel-button
      text-button="SIM"
    />
  </Main>
</template>
<script>
import EndorsementForm from "../components/EndorsementForm";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import RequestEndorsementMixin from "@/mixins/RequestEndorsementMixin";
import ModalConfirmReproveEndoserment from "@/modules/quotation/components/ModalGenericCriticism";
export default {
  data: () => ({
    form: null,
    formatDateToDDMMYYYY,
    breadcrumb: [
      {
        text: "Nova Solicitação Endosso",
        to: "policy"
      }
    ],
    modal: false,
    cloneForm: {},
    modalCancelReprove: false
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment,
    ModalConfirmReproveEndoserment
  },
  mixins: [RequestEndorsementMixin],
  methods: {
    checkSubmit(form) {
      if (form.tipo.id == "cancelamento_endosso") {
        this.openModalReprove();
      } else {
        this.submitNewRequestEndorsement(form);
      }
    },
    openModalReprove() {
      this.modalCancelReprove = true;
    },
    closeModalReprove(value) {
      this.modalCancelReprove = false;
      if (value) this.submitNewRequestEndorsement(this.form);
    }
  }
};
</script>
